import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Form, FormGroup, Label, Input, Button, } from 'reactstrap'

class EnterCode extends Component {
  constructor(props) {
    super(props)

    this.state = {
      registrationCode: ''
    }
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  render() {
    return (
      <Card>
        <CardHeader>
          Registration
        </CardHeader>
        <CardBody>
          <Form 
            onSubmit={(e) => {
              e.preventDefault()
              this.props.submitCode(this.state.registrationCode)
            }}>
            <FormGroup>
              <Label htmlFor='registrationCode'>Enter your registration code (capitalization and symbols matter):</Label>
              <Input
                type='text'
                id='registrationCode'
                name='registrationCode'
                placeholder='xY_72bmm'
                value={this.state.registrationCode}
                onChange={(e) => this.handleChange(e)}
              />
            </FormGroup>
          </Form>  
          <Button 
              color='primary' 
              onClick={() => {
                this.props.submitCode(this.state.registrationCode)
//                this.props.clearError()
              }}
              disabled={this.props.isFetching || !this.state.registrationCode}
            >
              {this.props.isFetching ? <i className="fa fa-spinner fa-lg fa-spin"></i> : 'Submit'}
            </Button>      
        </CardBody>
      </Card>
    )
  }
}

export default EnterCode


// WEBPACK FOOTER //
// ./src/components/Users/RegisterWithCode/EnterCode.js